import { Component, OnInit } from '@angular/core';
import { SnippetBlock } from 'libs/ngx-email-builder/src/lib/blocks/snippet/snippet.block';

@Component({
  selector: 'app-snippet-block',
  templateUrl: './snippet-block.component.html',
  styleUrls: ['./snippet-block.component.scss']
})
export class SnippetBlockComponent extends SnippetBlock {


}
